import React from "react";

const Section8 = () => {
  return (
    <section className="container-1280 md:my-[-10px] xl:min-w-[70%] lg:min-w-[90%] w-[95%] m-auto">
      <div className="flex flex-col items-center md:flex-row md:justify-start justify-evenly md:gap-24">
        <div>
          <h2 className="text-[26px] md:text-[30px] text-[#ea2339] font-bold">Our Awards</h2>
        </div>
        <div className="flex items-center gap-8 md:gap-16">
          <img
            src="../../../../assets/go-awards-logo-removebg-preview.png"
            alt=""
            className="w-32 h-auto md:w-32 md:h-auto"
          />
          <img
            src="../../../assets/award2.png"
            alt=""
            className="w-20 h-auto md:w-24 md:h-auto"
          />
        </div>
      </div>
      <div className="w-full h-px mt-10 bg-gray-800"></div>
    </section>
  );
};

export default Section8;
